import PropTypes from 'prop-types';

import Image from '../Image';
import css from './index.module.scss';

const Item = ({ copy, image, imageTreatment, social, title, url }) => {
  const kid = (
    <>
      {image && <Image className={css.image} {...image} treatment={imageTreatment} />}
      <h4 className={css.imageTitle}>{title}</h4>
      {copy && <div className={css.imageCopy} dangerouslySetInnerHTML={{ __html: copy }} />}
      {social && <div className={css.imageSocial} dangerouslySetInnerHTML={{ __html: social }} />}
    </>
  );
  return (
    <li className={css.item}>
      {!!url && (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {kid}
        </a>
      )}
      {!url && kid}
    </li>
  );
};

Item.defaultProps = {
  image: false,
};
Item.propTypes = {
  imageTreatment: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  copy: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  social: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

const ImageSet = ({ images, title, copy }) => (
  <div className={css.root}>
    <h3 className={css.title}>{title}</h3>
    <p className={css.copy}>{copy}</p>
    <ul className={css.list}>
      {images.map((image) => (
        <Item {...image} key={image.id} />
      ))}
    </ul>
  </div>
);

ImageSet.propTypes = {
  copy: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ).isRequired,
  title: PropTypes.string.isRequired,
};

export default ImageSet;
